/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Import_ZoteroInputs */

const en_dashboard_import_zotero = /** @type {(inputs: Dashboard_Import_ZoteroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import from Zotero`)
};

const es_dashboard_import_zotero = /** @type {(inputs: Dashboard_Import_ZoteroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar desde Zotero`)
};

/**
* | output |
* | --- |
* | "Import from Zotero" |
*
* @param {Dashboard_Import_ZoteroInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_import_zotero = /** @type {((inputs?: Dashboard_Import_ZoteroInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Import_ZoteroInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_import_zotero(inputs)
	return en_dashboard_import_zotero(inputs)
});